import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

export default function FlowStepsVertical({
  steps,
  currentStep,
}: {
  steps: { id: string; title: string }[];
  currentStep: number;
}) {
  return (
    <nav aria-label="Progress">
      <ol className="space-y-0">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isLast = index === steps.length - 1;
          return (
            <li key={step.id} className="relative">
              <div
                aria-current={isCurrent ? 'step' : undefined}
                className="flex items-center gap-4 px-2 py-4"
              >
                <div className="relative shrink-0">
                  <div
                    className={cn(
                      'flex h-10 w-10 items-center justify-center rounded-full border-2 text-sm font-semibold',
                      isCompleted || isCurrent
                        ? 'border-selise-blue-500 bg-selise-blue-500 text-white shadow-sm'
                        : 'border-dashed border-border bg-transparent text-muted-foreground'
                    )}
                  >
                    {isCompleted ? (
                      <Check className="h-4 w-4" strokeWidth={2.5} />
                    ) : isCurrent ? (
                      <span>{index + 1}</span>
                    ) : (
                      <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                    )}
                  </div>
                  {!isLast && (
                    <div
                      aria-hidden
                      className={cn(
                        'absolute left-1/2 top-full h-4 w-0.5 -translate-x-1/2',
                        isCompleted ? 'bg-selise-blue' : 'bg-border'
                      )}
                    />
                  )}
                </div>
                <span
                  className={cn(
                    'text-sm leading-tight',
                    isCurrent
                      ? 'font-semibold text-[hsl(var(--fg))]'
                      : isCompleted
                        ? 'font-medium text-selise-blue'
                        : 'text-xs text-muted-foreground'
                  )}
                >
                  {step.title}
                </span>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
